import { Button } from "../components/Button";
import { TrustCallout } from "../components/TrustCallout";
import { useAdvanceSoon } from "../flow/useAdvanceSoon";
import { useFlow } from "../flow/FlowContext";
import { useT } from "../i18n";

export function LoveReadyScreen() {
  const { answers, setLoveReady, next, goToStep } = useFlow();
  const t = useT();
  const advance = useAdvanceSoon(next);

  return (
    <>
      <div className="prompt screen-enter">
        <header className="screen-head">
          <div className="screen-head__eyebrow">{t("loveReady.eyebrow")}</div>
          <h1 className="screen-head__title">{t("loveReady.title")}</h1>
          <p className="screen-head__text">{t("loveReady.text")}</p>
        </header>
        <div className="stack">
          <button
            type="button"
            className={`choice-card${answers.loveReady === true ? " is-selected" : ""}`}
            onClick={() => {
              setLoveReady(true);
              advance();
            }}
            aria-pressed={answers.loveReady === true}
          >
            <strong>{t("loveReady.yesTitle")}</strong>
            <span>{t("loveReady.yesBody")}</span>
          </button>
          <button
            type="button"
            className={`choice-card${answers.loveReady === false ? " is-selected" : ""}`}
            onClick={() => setLoveReady(false)}
            aria-pressed={answers.loveReady === false}
          >
            <strong>{t("loveReady.noTitle")}</strong>
            <span>{t("loveReady.noBody")}</span>
          </button>
          {answers.loveReady === false ? (
            <TrustCallout title={t("loveReady.comeBackTitle")}>
              {t("loveReady.comeBackBody")}
            </TrustCallout>
          ) : null}
        </div>
      </div>
      {answers.loveReady === false ? (
        <div className="shell__footer" style={{ paddingLeft: 0, paddingRight: 0 }}>
          <Button
            variant="ghost"
            onClick={() => {
              setLoveReady(null);
              goToStep("welcome");
            }}
          >
            {t("common.leaveForNow")}
          </Button>
        </div>
      ) : null}
    </>
  );
}
